import { keyframes, styled } from '@mui/system'
import { TTheme } from '@/core/theme'

const gradientAnimation = keyframes`
    0% {
        background-position: 0% 50%;
    }
    50% {
        background-position: 100% 50%;
    }
    100% {
        background-position: 0% 50%;
    }
`

export const TechnologiesSkeletonContent = styled('div')`
    display: flex;
    margin-top: 16px;
    flex-direction: column;
    gap: 16px;
`

export const Pulsate = styled('div')<{ theme?: TTheme }>`
    background: linear-gradient(
        -45deg,
        ${({ theme }) => theme?.colors.greys[200] || '#E6E6E6'},
        ${({ theme }) => theme?.colors.greys[100] || '#F2F2F2'},
        ${({ theme }) => theme?.colors.greys[200] || '#E6E6E6'},
        ${({ theme }) => theme?.colors.greys[100] || '#F2F2F2'}
    );
    background-size: 400% 400%;
    animation: ${gradientAnimation} 2.25s ease infinite;
    border-radius: 4px;
`

export const SearchSection = styled('div')`
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;
`

export const Search = styled(Pulsate)`
    flex: 1;
    max-width: 500px;
    height: 40px;
    border-radius: 8px;
`

export const TableSection = styled('div')<{ theme?: TTheme }>`
    display: flex;
    flex-direction: column;
    gap: 12px;
    border: 1px solid ${({ theme }) => theme?.colors.greys[200] || '#E6E6E6'};
    border-radius: 8px;
    padding: 12px;
    background-color: ${({ theme }) =>
        theme?.colors.semantic.backgroundSecondary || '#FFFFFF'};
`

export const TableHeader = styled('div')<{ theme?: TTheme }>`
    display: flex;
    gap: 0;
    width: 100%;
    padding: 12px 16px;
    background-color: ${({ theme }) => theme?.colors.greys[75] || '#F8F8F8'};
    border-radius: 4px;
    box-sizing: border-box;
`

export const TableHeaderCell = styled(Pulsate)`
    flex: 1;
    height: 20px;
`

export const TableRow = styled('div')<{ theme?: TTheme }>`
    display: flex;
    gap: 0;
    width: 100%;
    padding: 16px;
    border: 1px solid ${({ theme }) => theme?.colors.greys[200] || '#E6E6E6'};
    border-radius: 4px;
    box-sizing: border-box;
`

export const TableCell = styled('div')`
    flex: 1;
    display: flex;
    align-items: center;
    padding-right: 16px;
    box-sizing: border-box;

    &:last-child {
        padding-right: 0;
    }
`

export const CellContent = styled(Pulsate)`
    width: 100%;
    height: 20px;
`
